import React from 'react';
import { Backdrop } from '@mui/material';
import {BeatLoader} from 'react-spinners';
import LoaderIcon from '../Assets/images/loader.svg';

 const BiztantuLoader = ({open, children, isChildren, position="fixed" }) => {
    
    return (
        <div>
            <Backdrop  open ={open} style={{zIndex: 999999, color: "#3596F6", height: "100%"}}>
                <div>

                <img
                    src={LoaderIcon}
                    alt="loading"
                    style={{ width: 60, height: 60, animation: "spin 1.2s linear infinite" }}
                    />
                </div>
            </Backdrop>
            {isChildren && children}
        </div>
    )
}

export default BiztantuLoader;